import commonService from './commonService'
import utils from './utils'

const add = async (instance, signal = null) => {
  const feed = await commonService.add('payment', instance, signal, true)
  if (feed?.status_code != null && Number(feed.status_code) !== 0) {
    throw new Error(feed.message || 'Enregistrement du paiement impossible.')
  }
  return feed?.data ?? feed
}

const update = async (instance, signal = null) => {
  const feed = await commonService.update('payment', instance, signal, true)
  if (!feed || (feed.status_code != null && Number(feed.status_code) !== 0)) {
    throw new Error(feed?.message || 'Confirmation du paiement impossible.')
  }
  return feed
}

const delete_ = async (instance, signal = null) => {
  return await commonService.delete_('payment', instance.id, signal)
}

const pay = async (data, signal = null) => {
  const url = `${utils.url}/payment/pay`
  return await commonService.post(url, data, signal)
}

const checkPaymentStatus = async (reference, signal = null) => {
  const url = `${utils.url}/payment/check/${reference}`
  return await commonService.load(url, signal)
}

export default {
  add,
  update,
  delete_,
  pay,
  checkPaymentStatus,
}
